import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Layout, Spin } from 'antd';
import ManageOutsAuditTrailSearchFilters from './ManageOutsAuditTrailSearchFilters';
import ManageOutsAuditTrailOrders from './ManageOutsAuditTrailOrders';
import ManageOutsAuditTrailLogs from './ManageOutsAuditTrailLogs';
import { useResetManageOutsData } from './redux/hooks';
import { ErrorPage } from '../../common';
import { AUTH_ERROR_MSG } from '../../../common/constants';
import { redirectUrl } from '../../../common/apiConfig';
import './ManageOutsAuditTrail.less';

export default function ManageOutsAuditTrail() {
  const {
    fetchOrdersPending,
    fetchOrdersError,
    fetchAuditLogError,
    auditLogData,
    fetchAuditLogPending,
  } = useSelector(state => ({
    fetchOrdersPending: state.manageOutsAuditTrail.fetchOrdersPending,
    fetchOrdersError: state.manageOutsAuditTrail.fetchOrdersError,
    fetchAuditLogError: state.manageOutsAuditTrail.fetchAuditLogError,
    auditLogData: state.manageOutsAuditTrail.auditLogData,
    fetchAuditLogPending: state.manageOutsAuditTrail.fetchAuditLogPending,
  }));

  const { resetManageOutsData } = useResetManageOutsData();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchFilters, setSearchFilters] = useState({});

  // Redux survives unmount, so clear the tables on re-entry; the filters stay in session storage.
  useEffect(() => {
    resetManageOutsData();
    return () => resetManageOutsData();
  }, []); // eslint-disable-line

  const isErrorPage = fetchOrdersError;
  if (fetchOrdersError === AUTH_ERROR_MSG || fetchAuditLogError === AUTH_ERROR_MSG) {
    sessionStorage.clear();
    window.location.assign(redirectUrl);
  }

  return (
    <div className="manage-outs-audit-trail">
      <Spin size="large" tip="Loading..." spinning={fetchOrdersPending || fetchAuditLogPending}>
        <div className="customizations-layout-sider">
          <Layout>
            <Layout.Sider width="100%" theme="light">
              <ManageOutsAuditTrailSearchFilters
                searchFilters={searchFilters}
                setSelectedOrder={setSelectedOrder}
                setSearchFilters={setSearchFilters}
              />
            </Layout.Sider>
            <Layout.Content className="sub-layout-content">
              {isErrorPage ? (
                <ErrorPage />
              ) : (
                <>
                  <ManageOutsAuditTrailOrders
                    searchFilters={searchFilters}
                    selectedOrder={selectedOrder}
                    setSelectedOrder={setSelectedOrder}
                  />
                  {(auditLogData && auditLogData.length > 0) || fetchAuditLogError ? (
                    <ManageOutsAuditTrailLogs
                      searchFilters={searchFilters}
                      selectedOrder={selectedOrder}
                      setSearchFilters={setSearchFilters}
                      fetchAuditLogError={fetchAuditLogError}
                    />
                  ) : null}
                </>
              )}
            </Layout.Content>
          </Layout>
        </div>
      </Spin>
    </div>
  );
}

ManageOutsAuditTrail.propTypes = {};
ManageOutsAuditTrail.defaultProps = {};


